import { NavLink } from 'react-router';
import styles from './SegmentedControl.module.css';

export interface Segment<T extends string> {
  value: T;
  label: string;
  /** Renders the segment as a link (e.g. Drums: Library · Kit · Groove) */
  to?: string;
}

interface Props<T extends string> {
  label: string;
  segments: Segment<T>[];
  value: T;
  onChange?: (value: T) => void;
}

/** Library · Kit · Groove and Build · Mix (DESIGN_SYSTEM §3). */
export function SegmentedControl<T extends string>({ label, segments, value, onChange }: Props<T>) {
  const asLinks = segments.every((s) => s.to);
  return (
    <div className={styles.track} role={asLinks ? 'navigation' : 'group'} aria-label={label}>
      {segments.map((s) => {
        const on = s.value === value;
        const className = [styles.item, on && styles.on].filter(Boolean).join(' ');
        return s.to ? (
          <NavLink key={s.value} to={s.to} className={className} aria-current={on ? 'page' : undefined} replace>
            {s.label}
          </NavLink>
        ) : (
          <button key={s.value} type="button" className={className} aria-pressed={on} onClick={() => onChange?.(s.value)}>
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
